import { Card } from '@devfolioco/genesis';
import { Manager, Reference, Popper } from 'react-popper';
import React from 'react';

import * as S from './style';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: props.visible,
    };
  }

  componentDidUpdate(prevProps) {
    const { visible } = this.props;

    if (visible !== prevProps.visible) {
      this.setState({ visible });
    }
  }

  onChildOver = () => {
    const { visible } = this.props;

    if (!visible) {
      this.setState({ visible: true });
    }
  };

  onChildOut = () => {
    const { visible } = this.props;

    if (!visible) {
      this.setState({ visible: false });
    }
  };

  render() {
    const { data, children, placement = 'top', style: propStyle, popperStyle } = this.props;
    const { visible } = this.state;

    return (
      <Manager>
        <Reference>
          {props => (
            <div
              style={{ display: 'inline-block' }}
              {...props}
              onFocus={this.onChildOver}
              onBlur={this.onChildOut}
              onMouseOver={this.onChildOver}
              onMouseOut={this.onChildOut}
            >
              {children(props)}
            </div>
          )}
        </Reference>

        <Popper placement={placement}>
          {({ ref, style, placement: placementProp, arrowProps }) =>
            visible ? (
              <div ref={ref} style={{ ...style, zIndex: 1000000, ...popperStyle }} data-placement={placementProp}>
                <Card background="grey-8" elevation={5} noPadding upgrade style={{ textAlign: 'center', ...propStyle }}>
                  <div style={{ padding: 20, color: '#fff' }}>
                    {data({ ref, style, placement: placementProp, arrowProps })}
                  </div>
                </Card>

                <S.Arrow ref={arrowProps.ref} style={arrowProps.style} data-placement={placementProp} />
              </div>
            ) : null
          }
        </Popper>
      </Manager>
    );
  }
}

export default Tooltip;
